<template>
  <div class="fulfillShell">
    <v-tabs height="52" class="fulfillTabs" centered v-model="selectedTab">
      <v-tab href="#to-fulfill">
        To Fulfill
        <v-badge
          v-if="ordersToFulfill.length"
          inline
          :content="ordersToFulfill.length"
        ></v-badge>
      </v-tab>
      <v-tab href="#in-fulfill"
        >Currently Fulfilling
        <v-badge
          v-if="ordersInFulfill.length"
          inline
          :content="ordersInFulfill.length"
        ></v-badge
      ></v-tab>
      <v-tab href="#errors"
        >Errors
        <v-badge
          v-if="ordersWithError.length"
          inline
          :content="ordersWithError.length"
        ></v-badge
      ></v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="to-fulfill">
        <OrdersToFulfill />
      </v-tab-item>

      <v-tab-item value="in-fulfill">
        <OrdersInFulfill />
      </v-tab-item>

      <v-tab-item value="errors">
        <OrdersWithError />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import OrdersToFulfill from "@/components/FulfillOrders/components/OrdersToFulfill";
import OrdersInFulfill from "@/components/FulfillOrders/components/OrdersInFulfill";
import { mapActions, mapGetters } from "vuex";
import OrdersWithError from "@/components/FulfillOrders/components/OrdersWithError";

export default {
  name: "FulfillOrders",
  components: {OrdersWithError, OrdersInFulfill, OrdersToFulfill },
  data() {
    return {
      selectedTab: "to-fulfill",
    };
  },
  computed: {
    ...mapGetters(["ordersToFulfill", "ordersToFulfillManual", "ordersInFulfill", "ordersWithError"]),
  },
  mounted() {
    this.loadOrders();
  },
  methods: {
    ...mapActions(["loadOrders"]),
  },
};
</script>

<style scoped lang="scss">
/* ── Moderne Shell: Pill-Tabs + einheitliches Tabellen-Styling für alle
   drei Tabs (To Fulfill / Currently / Errors erben es automatisch) ── */
.fulfillShell {
  padding: 4px;
}

::v-deep .fulfillTabs {
  margin-bottom: 14px;
}

::v-deep .v-tabs-items {
  background: transparent !important;
}

/* Tabellen aller Tabs: moderne Karte + ruhige Typo */
::v-deep .v-data-table {
  border-radius: 14px !important;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06), 0 4px 14px rgba(16, 24, 40, 0.07) !important;
  overflow: hidden;

  .v-data-table__wrapper > table > thead > tr > th {
    font-size: 11px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: rgba(0, 0, 0, 0.45) !important;
    white-space: nowrap;
    background: #faf9fc;
  }
  .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 13.5px;
  }
  .v-data-table__expanded__content {
    box-shadow: none !important;
    background: #f6f5fa;
  }
}
</style>
